export const blockIconsAudioandvideoPauseCircleNew = (
	<span className='material-symbols-outlined'>pause_circle</span>
);
